import { OperatorType } from '../operator';
import { IntervalUnit } from '../timeout';

export type ActionSetVarOperationServer =
  | ActionSetVarSetServer
  | ActionSetVarNumberFromOperationServer
  | ActionSetVarDateFromOperationServer;

export enum SetVarsKind {
  set = 'set',
  numOp = 'num_op',
  dateOp = 'date_op'
}

export type SetDateVarOperatorType =
  | OperatorType.addition
  | OperatorType.subtraction;

export type SetDateVarUnitType =
  | IntervalUnit.days
  | IntervalUnit.hours
  | IntervalUnit.minutes
  | IntervalUnit.seconds;

export type ActionSetVarBaseServer<
  K extends SetVarsKind,
  V extends string | Record<string, any>
> = {
  kind: K;
  lhs: string;
  rhs: V;
};

export type ActionSetVarSetServer = ActionSetVarBaseServer<
  SetVarsKind.set,
  string
>;

export type ActionSetVarNumberFromOperationServer = ActionSetVarBaseServer<
  SetVarsKind.numOp,
  SetVarNumberOperationServer
>;

export type ActionSetVarDateFromOperationServer = ActionSetVarBaseServer<
  SetVarsKind.dateOp,
  SetVarDateOperationServer
>;

export type SetVarNumberOperationServer = {
  arg1: string;
  arg2: string;
  op: OperatorType;
};

export type SetVarDateOperationServer = {
  arg1: string;
  arg2: string;
  op: SetDateVarOperatorType;
  unit: SetDateVarUnitType;
};
